import {
    FOLIO_LIST_KARVY_RESPONSE, FOLIO_LIST_KARVY_FAILED, GET_REGISTERED_BANKS_RESPONSE, GET_REGISTERED_BANKS_FAILED,
    ORDER_GENERATION_RESPONSE, ORDER_GENERATION_FAILED, PAYMENT_REQUEST_RESPONSE, PAYMENT_REQUEST_FAILED,
    GET_PG_RESPONSE_RESPONSE, GET_PG_RESPONSE_FAILED, VALIDATE_BROKER_CODE_RESPONSE, VALIDATE_BROKER_CODE_FAILED,
    FOLIO_BROKER_LIST_RESPONSE, FOLIO_BROKER_LIST_FAILED, UPDATE_FOLIO_BROKER_LIST,
    BUCKET_ID_RESPONSE, BUCKET_ID_FAILED, BUCKET_ID, DIT_URL_DETAILS, SELECTED_OPTION, UPDATE_URL_DETAILS_FOR_QUICK_INVEST
} from "../types/quickbuy";

const initialState = {
    getfolioList: {},
    registerBankList: {},
    orderGenerationList: {},
    paymentRequest: {},
    pgResponse: {},
    validateBroker: {},
    folioBrokerList: {},
    bucketID: '',
    urlDeatils: {},
    selectedOption: ''
}

export default function reducer(state = initialState, action) {
    let payload = action.payload;
    switch (action.type) {
        case FOLIO_LIST_KARVY_RESPONSE:
            return { ...state, getfolioList: action.payload }
        case FOLIO_LIST_KARVY_FAILED:
            return { ...state, getfolioList: action.payload }
        case GET_REGISTERED_BANKS_RESPONSE:
            return { ...state, registerBankList: action.payload }
        case GET_REGISTERED_BANKS_FAILED:
            return { ...state, registerBankList: action.payload }
        case ORDER_GENERATION_RESPONSE:
            return { ...state, orderGenerationList: action.payload }
        case ORDER_GENERATION_FAILED:
            return { ...state, orderGenerationList: action.payload }
        case PAYMENT_REQUEST_RESPONSE:
            return { ...state, paymentRequest: action.payload }
        case PAYMENT_REQUEST_FAILED:
            return { ...state, paymentRequest: action.payload }
        case GET_PG_RESPONSE_RESPONSE:
            return { ...state, pgResponse: action.payload }
        case GET_PG_RESPONSE_FAILED:
            return { ...state, pgResponse: action.payload }
        case VALIDATE_BROKER_CODE_RESPONSE:
            return { ...state, validateBroker: action.payload }
        case VALIDATE_BROKER_CODE_FAILED:
            return { ...state, validateBroker: action.payload }
        case FOLIO_BROKER_LIST_RESPONSE:
            return { ...state, folioBrokerList: action.payload }
        case FOLIO_BROKER_LIST_FAILED:
            return { ...state, folioBrokerList: action.payload }
        case UPDATE_FOLIO_BROKER_LIST:
            return { ...state, folioBrokerList: { ...state.folioBrokerList, ...action.payload } }
        case BUCKET_ID_RESPONSE:
            return { ...state, bucketID: action.payload }
        case BUCKET_ID_FAILED:
            return { ...state, bucketID: action.payload }
        case BUCKET_ID:
            return { ...state, bucketID: action.payload }
        case DIT_URL_DETAILS:
            return { ...state, urlDeatils: action.payload }
        case SELECTED_OPTION:
            return { ...state, selectedOption: action.payload }
        case UPDATE_URL_DETAILS_FOR_QUICK_INVEST: {
            let newUrlDeatils = { ...state.urlDeatils, ...action.payload };
            return { ...state, urlDeatils: newUrlDeatils }
        }
        default:
            return state
    }

}